// src/config/permissions.js

// This is the single source of truth for all possible permissions in the system.
export const allPermissions = [
  "users.view",
  "users.create",
  "users.update",
  "roles.view",
  "roles.create",
  "sales_agents.view",
  "suppliers.view",
  "customers.view",
  "customer_groups.view",
  "contacts.import",
  "chefs.view",
  "raw_products.view",
  "raw_products.create",
  "categories.view",
  "products.view",
  "food_items.view",
  "packages.view",
  "inventory.view",
  "inventory.create",
  "subscriptions.view",
  "subscriptions.manage",
  "addons.view",
  "addons.manage",
  "hubs.view",
  "hubs.manage",
  "hubs.create",
  "delivery.assign",
  "delivery_person.manage",
  "wallet.view",
  "kitchen.dashboard",
  "kitchen.requests",
  'food_items.create',
  'food_items.update',
  'packages.create',
  'packages.update',
  "banner.manage",
  "meals.view",
  "location.view",
  "expenses.view",
  "expenses.create",
  "expense_categories.manage",
  'categories.create',
  'categories.update',
  'categories.delete',
  'grocery_products.create',
  'grocery_products.update',
  'grocery_products.delete',
  'raw_products.delete',
  'roles.update',
'roles.delete',
];